import React from 'react';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import HeroRadar from "./heroRadar";
import { useData } from '../../dataProvider';
import '../styles/heroesDiagramsStyle.css'

function HeroesDiagram() {
	const {radiantName, direName, status, stats, isDark } = useData()

	return (
		<Card className="fullwidth">
			<CardContent>
				<Typography variant="h6" style={{ textAlign: 'center' }}>
					Преимущество персонажей {radiantName} против персонажей {direName}
				</Typography>
				<Grid container style={{ marginTop: '2rem' }}>
					{status === 'ready' &&
						stats.map((item) => {
							if (Object.values(item)[0] === null) {
								return null;
							}
							return (
								<Grid item xs={12} md={6} key={Object.keys(item)[0]}>
									<HeroRadar heroData={item} isDark={isDark} />
								</Grid>
							);
					})}
				</Grid>
			</CardContent>
		</Card>
	);
}

export default HeroesDiagram;
